import { render } from "./NewsModal.vue?vue&type=template&id=08a4641f&scoped=true"
import script from "./NewsModal.vue?vue&type=script&lang=js"
export * from "./NewsModal.vue?vue&type=script&lang=js"

import "./NewsModal.vue?vue&type=style&index=0&id=08a4641f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a4641f"]])

export default __exports__